import { produce } from 'immer'
import type { State } from '../../typings'
import { EmployeeUserPayload } from './typings'

export function setEmployeeProducer(state: State, payload: EmployeeUserPayload): State {
  
  return produce(state, (draft) => {
    draft.referralEmployeeValue =  payload.name || ''
    draft.referralEmployeeId = payload.id || ''
  })
}
